<template>
  <div
    class="ag-grid__overlay-form-box"
  >
    <div
      v-t="'TRANSCRIBE_CALLS'"
      class="ag-grid__overlay-form-box-title"
    />
    
    <div class="form-horizontal p-15">
      <template v-if="!selectedCalls.length">
        <div class="f-s-16 p-l-15 col-md-offset-3 m-b-10">
          {{ $t('TRANSCRIBE_CALLS_NUMBER', { adjustmentCount }) }}
        </div>
        <div class="f-s-12 p-l-15 col-md-offset-3 m-b-10">
          {{ $t('TRANSCRIBE_CALLS_MESSAGE', { adjustmentCount }) }}
        </div>
      </template>
      <template v-else>
        <div class="p-l-15 m-b-10 col-md-offset-3">
          <BulkCallDetails
            :key="bulkCallReviewKey"
            :selected-calls="selectedCalls"
            @unselectCallOnBulkAction="unselectCallOnBulkAction"
          />
        </div>
        <div class="f-s-12 p-l-15 col-md-offset-3 m-b-10">
          {{ $t('TRANSCRIBE_SELECTED_CALLS_MESSAGE') }}
        </div>
      </template>
      <div>
        <div
          v-html="$t('TRANSCRIBE_CALLS_FEE_MESSAGE')"
          class="f-s-12 p-l-15 col-md-offset-3 m-b-10"
        />
        <div class="checkbox f-s-12 p-l-15 col-md-offset-3 col-sm-offset-2 m-b-5">
          <label>
            <input
              type="checkbox"
              v-model="confirmTranscription"
            />
            <div class="p-t-2" v-t="'TRANSCRIBE_CALLS_ATTEST'"></div>
          </label>
        </div>
        <div class="form-group">
          <div class="col-sm-offset-2 col-md-offset-3 col-md-7">
            <PrimaryButton
              size="sm"
              :disabled="!confirmTranscription || showLoader"
              :show-loader-on-form="showLoader"
              @click="callTranscriptionSubmit"
            >
              <span v-t="'TRANSCRIBE_SEND_BTN'" />
            </PrimaryButton>

            <button
              v-t="'CANCEL'"
              type="button"
              class="btn btn-sm btn-danger m-l-15"
              @click="hideBulkForm"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import 'moment-timezone';
import { reportingService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { mapGetters } from 'vuex';

import messages from './locales';
import sharedMessages from '@/core/locales';
import BulkCallDetails from '../BulkCallDetails';
import PrimaryButton from '@/core/components/PrimaryButton';
import bulkCallActionMixin from './mixins/bulkCallActionMixin';

export default {
  name: 'BulkTranscriptionForm',

  components: {
    BulkCallDetails,
    PrimaryButton
  },

  mixins: [bulkCallActionMixin],

  props: {
    isAdmin: {
      type: Boolean,
      default: false
    },
    totalCallsCount: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      confirmTranscription: false,
    };
  },
  computed: {
    ...mapGetters('reporting', [
      'activeCallLogTimeRange',
      'activeCallLogTranslatedTimeZoneId',
      'activeCallLogFilterCriteria',
      'activeCallLogLastUpdated'
    ]),
    adjustmentCount() {
      return this.selectedCalls.length ? this.selectedCalls.length : this.totalCallsCount;
    },
  },
  methods: {
    callTranscriptionSubmit() {
      const reportDateRange = reportingService.getReportingDateRange(this.activeCallLogTimeRange, this.activeCallLogTranslatedTimeZoneId);
      const reportFilters = [
        ...reportingService.getFilterFromFilterCriteria(this.activeCallLogFilterCriteria)
      ];
      const callIds = this.selectedCalls.length ? this.selectedCalls.map(call => call.inboundCallId) : null;
      const callLog = {
        reportStart: reportDateRange.reportStart,
        reportEnd: reportDateRange.reportEnd,
        reportRequestTime: moment.tz(this.activeCallLogLastUpdated, this.activeCallLogTranslatedTimeZoneId).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
        totalRequestedCount: this.totalCallsCount,
        formatTimeZone: this.activeCallLogTranslatedTimeZoneId,
        filters: reportFilters
      };

      if (callIds) {
        // Request to endpoint sending callIds
        this.$emit('bulkCallTranscription', { 
          callIds: callIds,
        });
      } else {
        // Request to endpoint sending report query
        this.$emit('bulkCallTranscriptionByLogs', { 
          callLog: callLog,
        });
      }
    },
  },

  i18n: {
    locale: 'en',
    messages,
    sharedMessages
  }
};
</script>